import { CANDIDATE_TIMELINE_RECORDS_ALIAS } from 'domain/shared/candidate';
import ExpectedCompensationLayout from './ExpectedCompensationLayout';

const useCandidateExpectedCompensationItem = () => ({
  isApplicable: (item: any) => item && item.type === CANDIDATE_TIMELINE_RECORDS_ALIAS.EXPECTED_COMPENSATION,
  source: 'note',
  name: 'Compensations',
  withoutAddFunctionality: true,
  RecordLayout: ExpectedCompensationLayout,
  hasFullData: true,
});

export default useCandidateExpectedCompensationItem;
